import React from 'react';
import "./FAQ.css";

const FAQ = () => (
  <div className="policy-container">
    <h2 className="faq-title">Frequently Asked Questions</h2>
    <div className="faq-list">

      <div className="faq-item">
        <h4 className="faq-question">Q: Do you ship internationally?</h4>
        <p className="faq-answer">
          Yes, we ship worldwide. Delivery fees and timelines vary depending on your country.
        </p>
      </div>

      <div className="faq-item">
        <h4 className="faq-question">Q: How long does delivery take within Nigeria?</h4>
        <p className="faq-answer">
          Abuja deliveries take 3–7 working days. For other Nigerian states, allow 5–10 working days.
        </p>
      </div>

      <div className="faq-item">
        <h4 className="faq-question">Q: How long does international delivery take?</h4>
        <p className="faq-answer">
          On average, 7–14 working days, depending on your country and courier service.
        </p>
      </div>

      <div className="faq-item">
        <h4 className="faq-question">Q: Are Posher pieces limited?</h4>
        <p className="faq-answer">
          Yes, we release exclusive drops in small quantities to maintain luxury and rarity. Once sold out, pieces are rarely restocked.
        </p>
      </div>

      <div className="faq-item">
        <h4 className="faq-question">Q: Can I order custom designs?</h4>
        <p className="faq-answer">
          Yes, we accept a limited number of custom or bridal orders. Kindly send us a message to discuss availability.
        </p>
      </div>

      <div className="faq-item">
        <h4 className="faq-question">Q: How can I reach Posher on social media?</h4>
        <p className="faq-answer">
          You can find us on Instagram <a href="https://instagram.com/posherofficial" target="_blank" rel="noreferrer">@posherofficial</a> for new drops, updates, and styling inspiration.
        </p>
      </div>

    </div>
  </div>
);

export default FAQ;
